// --------------- import external dependencies --------------
import React from "react";
import { useFormik } from "formik";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
// -------------- import internal dependencies --------------
import AuthLayout from "../../../layouts/authLayout/AuthLayout";
// ----- import hooks -------
import useAuth from "../hooks/useAuth";
import { ResetPasswordValidator } from "../../../utils/validators/auth";
import FormInput from "../../../components/Forms/input/FormInput";
import {
  FormWrapper,
  FormHeaderText,
  Button,
  FormSubTitle,
  TextLight,
} from "../styles/auth";

const ResetPassword = () => {
  // ------- intialize custom hooks -------
  const { requestDotNetPasswordReset } = useAuth();
  const navigate = useNavigate();

  const { isLoading, mutateAsync: reset } = requestDotNetPasswordReset;

  const formik = useFormik({
    initialValues: {
      Email: "",
    },
    validationSchema: ResetPasswordValidator(),
    onSubmit: async (values: any) => {
      try {
        await reset({ usernameOrEmail: values.Email });
      } catch (error: any) {
        // Errors are swallowed and the navigation below is unconditional so this screen
        // cannot reveal which accounts exist.
        console.log(error?.response?.data);
      }

      navigate("/success?action=email");
    },
  });

  return (
    <AuthLayout>
      <FormWrapper>
        <FormHeaderText>Reset Password</FormHeaderText>
        <FormSubTitle>
          Enter your username or the email associated with your account and
          we’ll send you a link to reset your password.
        </FormSubTitle>
        <form name="loginForm" onSubmit={formik.handleSubmit}>
          <FormInput
            data-testid="reset-email-input"
            label={"Username or Email"}
            name="Email"
            value={formik.values.Email}
            placeholder="Enter username or email"
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            errorMessage={
              formik.touched.Email && formik.errors.Email
                ? formik.errors.Email
                : null
            }
          />

          <Button disabled={isLoading}>
            {" "}
            {isLoading ? "Sending" : "Continue"}{" "}
          </Button>
          <div className="mt-4 text-center text-sm font-medium">
            <div>If you do not receive this mail</div>
            <div>
              <TextLight>Please check in with your manager</TextLight>
            </div>
          </div>
        </form>
      </FormWrapper>
    </AuthLayout>
  );
};

export default ResetPassword;
